import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=10b6ef8c&scoped=true"
var script = {}
import style0 from "./Test.vue?vue&type=style&index=0&id=10b6ef8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b6ef8c",
  null
  
)

export default component.exports